// Tappable contact links — on mobile these open the dialer / maps / mail app.

export function PhoneLink({ phone }: { phone: string | null | undefined }) {
  if (!phone) return <span style={{ color: 'var(--gray)' }}>—</span>
  const dial = phone.replace(/[^\d+]/g, '')
  return <a href={`tel:${dial}`}>{phone}</a>
}

export function AddressLink({ address }: { address: string | null | undefined }) {
  if (!address) return <span style={{ color: 'var(--gray)' }}>—</span>
  // Universal Google Maps search URL — opens the Maps app on iOS/Android, the
  // web map on desktop.
  const href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
  return (
    <a href={href} target="_blank" rel="noreferrer">
      {address}
    </a>
  )
}

export function EmailLink({ email }: { email: string | null | undefined }) {
  if (!email) return <span style={{ color: 'var(--gray)' }}>—</span>
  return <a href={`mailto:${email}`}>{email}</a>
}
